import { z } from "zod";
/**
 * Weight and temperature are always expressed with an explicit unit
 * (`COMPANY.md` "Target Market": "distances/times carry an explicit unit in
 * the data model" — the same "never hardcode a unit" rule extends to every
 * other measurement). Metric is the only unit exposed in the UI at launch;
 * Imperial is modeled so a later locale can enable it without a data
 * migration.
 */
export const MASS_UNITS = ["KILOGRAMS", "POUNDS"];
export const MassUnitSchema = z.enum(MASS_UNITS);
export const TEMPERATURE_UNITS = ["CELSIUS", "FAHRENHEIT"];
export const TemperatureUnitSchema = z.enum(TEMPERATURE_UNITS);
/**
 * Loose sanity bounds shared by every Mass/Temperature reading, independent
 * of which unit was used to enter it (`packages/stable/src/validation.ts` is
 * where these are actually enforced via Zod). Kept generous — this is a
 * manual log, not a veterinary-grade instrument, so the domain does not
 * second-guess a Horseman's entered number beyond rejecting garbage input.
 */
export const CARE_RECORD_VALUE_MIN = 0;
export const CARE_RECORD_VALUE_MAX = 10_000;
